<template>

  <m-c100 :image="product.thumbnail">

    <template #p-1>
      <router-link class="text-decoration-none" :to="{name:'Product', params:{name:product.raw_link}}">
        <h4 class="text-dark">{{ product.name }}</h4>
      </router-link>
      <p class="text-muted" v-if="product.description" v-html="product.description.slice(0, 60)"/>


    </template>

    <template #p-2>
      <b-row>
        <b-col class="text-center">
          <m-product-price-100 :product="product"/>
        </b-col>
      </b-row>
      <m-shopping-cart-controller-1 :product="product"/>

    </template>

  </m-c100>

</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {isProductActive} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Timing";
import {addUnAuthItem, basketAddItem} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";

export default {
  name: "ProductCard",
  props: ['product'],
  computed: {
    IsAuthenticated() {
      return this.$store.getters["User/isAuthenticated"];
    },
  },
  methods: {
    formatNumber,
    isProductActive,
    basketAddItem,
    addUnAuthItem,
  }
}
</script>

<style>
.product-price .d-flex{
  display: inline !important;
}
</style>

<style scoped>
.discount {
  color: var(--secondary);
}

.show-product {
  background-color: var(--light-orange);
  color: white;
}

.btn-container {
  height: 100%;
}


</style>